import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FoodPriceList from './price/FoodPriceList';
import FoodSideDish from './side-dish/SideDish';
import AddFoodNoteButton from './note/AddFoodNoteButton';

interface FoodAdditionalDrawerViewProps {
    restaurantOfferStore: RestaurantOfferStore
}

const FoodAdditionalDrawerView: React.FC<FoodAdditionalDrawerViewProps> = observer(({ restaurantOfferStore }) => {
    const { orderFoodRequest } = restaurantOfferStore;
    if (orderFoodRequest === undefined) {
        return null;
    }

    return (
        <Grid>
            {<FoodPriceList restaurantOfferStore={restaurantOfferStore} />}
            {<FoodSideDish restaurantOfferStore={restaurantOfferStore} />}
            {<AddFoodNoteButton restaurantOfferStore={restaurantOfferStore} />}
        </Grid>
    )
})

export default FoodAdditionalDrawerView;